import { useMemo } from 'react'
import isDevelopment from './isDevelopment'
import isStaging from './isStaging'

export default (type, id, size) => useMemo(() => {
  if (!type || !id) {
    return null
  }

  let baseUri = 'https://infowijs-avatars.s3.eu-west-1.amazonaws.com'
  if (isDevelopment || isStaging) {
    baseUri = 'https://infowijs-avatars-staging.s3.eu-west-1.amazonaws.com'
  }
  return `${baseUri}/${type}/${id}_${size}.png`
}, [type, id, size])
